import { CALL_API } from '../middleware/ApiMiddleware';

export const LOCATION_CUSTOM_FIELDS_FETCH_REQUEST = 'LOCATION_CUSTOM_FIELDS_FETCH_REQUEST';
export const LOCATION_CUSTOM_FIELDS_FETCH_SUCCESS = 'LOCATION_CUSTOM_FIELDS_FETCH_SUCCESS';
export const LOCATION_CUSTOM_FIELDS_FETCH_FAILURE = 'LOCATION_CUSTOM_FIELDS_FETCH_FAILURE';

export const LOCATION_CUSTOM_FIELD_CREATE_REQUEST = 'LOCATION_CUSTOM_FIELD_CREATE_REQUEST';
export const LOCATION_CUSTOM_FIELD_CREATE_SUCCESS = 'LOCATION_CUSTOM_FIELD_CREATE_SUCCESS';
export const LOCATION_CUSTOM_FIELD_CREATE_FAILURE = 'LOCATION_CUSTOM_FIELD_CREATE_FAILURE';

export const LOCATION_CUSTOM_FIELD_EDIT_REQUEST = 'LOCATION_CUSTOM_FIELD_EDIT_REQUEST';
export const LOCATION_CUSTOM_FIELD_EDIT_SUCCESS = 'LOCATION_CUSTOM_FIELD_EDIT_SUCCESS';
export const LOCATION_CUSTOM_FIELD_EDIT_FAILURE = 'LOCATION_CUSTOM_FIELD_EDIT_FAILURE';

export const LOCATION_CUSTOM_FIELD_FETCH_REQUEST = 'LOCATION_CUSTOM_FIELD_FETCH_REQUEST';
export const LOCATION_CUSTOM_FIELD_FETCH_SUCCESS = 'LOCATION_CUSTOM_FIELD_FETCH_SUCCESS';
export const LOCATION_CUSTOM_FIELD_FETCH_FAILURE = 'LOCATION_CUSTOM_FIELD_FETCH_FAILURE';

export const LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_REQUEST = 'LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_REQUEST';
export const LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS = 'LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS';
export const LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE = 'LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE';

export const LCFS_FETCH_REQUEST = 'LCFS_FETCH_REQUEST';
export const LCFS_FETCH_SUCCESS = 'LCFS_FETCH_SUCCESS';
export const LCFS_FETCH_FAILURE = 'LCFS_FETCH_FAILURE';

const baseURL = 'config/gis/location-fields';

export const fetchLocationCustomFields = (params?: ILocationFieldParams) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [
      LOCATION_CUSTOM_FIELDS_FETCH_REQUEST,
      LOCATION_CUSTOM_FIELDS_FETCH_SUCCESS,
      LOCATION_CUSTOM_FIELDS_FETCH_FAILURE,
    ],
  },
});

export const createLocationCustomField = (newLocationCustomFieldRequest: ILocationFieldRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: newLocationCustomFieldRequest,
    authenticated: true,
    types: [
      LOCATION_CUSTOM_FIELD_CREATE_REQUEST,
      LOCATION_CUSTOM_FIELD_CREATE_SUCCESS,
      LOCATION_CUSTOM_FIELD_CREATE_FAILURE,
    ],
  },
});

export const editLocationCustomField = (
  locationCustomFieldId: number,
  newLocationCustomFieldRequest: ILocationFieldRequest
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${locationCustomFieldId}`,
    method: 'put',
    body: newLocationCustomFieldRequest,
    authenticated: true,
    types: [LOCATION_CUSTOM_FIELD_EDIT_REQUEST, LOCATION_CUSTOM_FIELD_EDIT_SUCCESS, LOCATION_CUSTOM_FIELD_EDIT_FAILURE],
  },
});

export const fetchLocationCustomField = (locationCustomFieldId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${locationCustomFieldId}`,
    method: 'get',
    authenticated: true,
    types: [
      LOCATION_CUSTOM_FIELD_FETCH_REQUEST,
      LOCATION_CUSTOM_FIELD_FETCH_SUCCESS,
      LOCATION_CUSTOM_FIELD_FETCH_FAILURE,
    ],
  },
});

export const editLocationCustomFieldSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    types: [
      LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_REQUEST,
      LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS,
      LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE,
    ],
  },
});

export const fetchLcfs = (agencyId: number, workspaceId?: number, hideLoading = false) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/location-custom-fields`,
    method: 'get',
    params: { workspaceId },
    authenticated: true,
    types: [LCFS_FETCH_REQUEST, LCFS_FETCH_SUCCESS, LCFS_FETCH_FAILURE],
    hideLoadingWidget: hideLoading,
  },
});
